<template>
  <g :class="cssClass" ref="gBg" />
</template>

<script>
import utils from '@/utils';
import * as d3 from 'd3';

export default {
  props: {
    data: {
      type: [Array, Number],
      required: true
    },
    direction: {
      type: String,
      required: true
    },
    scale: {
      type: Function,
      required: true
    },
    size: {
      type: Object,
      required: true
    },
    transition: {
      type: Object,
      required: false,
      default() {
        return {
          duration: 500,
          ease: d3.easeQuad
        };
      }
    },
    isDrawed: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      el: {
        gBg: ''
      },
      margin: 5
    };
  },

  computed: {
    cssClass() {
      if (this.isBgX) {
        return 'c-graph-bg__x';
      } else {
        return 'c-graph-bg__y';
      }
    },
    isArray() {
      return Array.isArray(this.data);
    },
    isBgX() {
      return this.direction === 'x';
    }
  },

  mounted() {
    this.setEl();
    if (this.isDrawed) {
      this.draw();
    }
  },

  methods: {
    setEl() {
      this.el.gBg = d3.select(this.$refs.gBg);
    },

    draw() {
      this.$nextTick(() => {
        if (this.isBgX) {
          this.drawBgX();
        } else {
          this.drawBgY();
        }
      });
    },

    drawBgX() {
      let axisBottom = d3
        .axisBottom(this.scale)
        .tickSizeInner(this.size.canvasH)
        .tickFormat('');

      if (this.isArray) {
        axisBottom.tickValues(this.data);
      } else {
        axisBottom.ticks(this.data);
      }

      this.el.gBg
        .attr('opacity', 0)
        .call(axisBottom)
        .interrupt()
        .transition()
        .duration(this.transition.duration)
        .ease(this.transition.ease)
        .attr('opacity', 1);

      this.el.gBg.selectAll('g').attr('opacity', (d, i, nodes) => {
        let translate = utils.getTranslateValue(
          nodes[i].getAttribute('transform')
        );
        if (
          translate[0] < this.size.graph.left + this.margin ||
          translate[0] > this.size.graph.right - this.margin
        ) {
          return 0;
        } else {
          return 1;
        }
      });
    },

    drawBgY() {
      let axisLeft = d3
        .axisLeft(this.scale)
        .tickSizeInner(-this.size.canvasW)
        .tickFormat('');

      if (this.isArray) {
        axisLeft.tickValues(this.data);
      } else {
        axisLeft.ticks(this.data);
      }

      this.el.gBg
        .attr('opacity', 0)
        .call(axisLeft)
        .interrupt()
        .transition()
        .duration(this.transition.duration)
        .ease(this.transition.ease)
        .attr('opacity', 1);

      this.el.gBg.selectAll('g').attr('opacity', (d, i, nodes) => {
        let translate = utils.getTranslateValue(
          nodes[i].getAttribute('transform')
        );
        if (
          translate[1] < this.size.graph.top + this.margin ||
          translate[1] > this.size.graph.bottom - this.margin
        ) {
          return 0;
        } else {
          return 1;
        }
      });
    },

    resize() {
      if (!this.isDrawed) {
        return;
      }
      this.$nextTick(() => {
        if (this.isBgX) {
          this.drawBgX();
        } else {
          this.el.gBg.selectAll('line').attr('x2', this.size.canvasW);
        }
      });
    }
  }
};
</script>
